<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- HEADER -->
      <SubpageHeader
        :is_sticky="true"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test('back')"
        @saveBtnClicked="test('save')"
        @cancelBtnClicked="test('cancel')"
      >
        <template #rightside>

        </template>
      </SubpageHeader>

      <div class="work-package-costs-container">
        <!-- STRATEGY -->
        <div class="work-package-costs-strategy">
          <DropDownOutlinedFlat
            label="Cost strategy"
            :options="[
              'Flat rate', 'Unit price', 'Hourly wages',
              'Material price', 'Material price and hourly wages'
            ]"
            :is_disabled="!is_edit"
            :width="140"
            :background_color="bg"
            :foreground_color="fg"
            @change="test($event)"
          />
          <LabelOutlined
            label="Strategy description"
            :is_disabled="true"
            :height="42.5"
            :dark="is_light_mode(fg)"
            :background_color="bg"
          >
            <template #content>
              <TText
                :text="'Ich bin eine Beschreibung und ich wachse dynamisch. Schau, wie ich meine Box größer mache :^)'"
                small
                :color="fg"
              />
            </template>
          </LabelOutlined>
        </div>

        <!-- TOTAL COST -->
        <div v-if="show_total" class="work-package-costs-total">
          <div v-if="show_budget" class="work-package-costs-equation">
            <ModularEquation
              :elements="total_budget_elements"
              :background_color="bg"
              :foreground_color="fg"
              @changed="test($event)"
            />
          </div>
          <div class="work-package-costs-equation">
            <ModularEquation
              :description="`${/*'Tendered'*/''}`"
              :elements="total_tendered_elements"
              :background_color="bg"
              :foreground_color="fg"
              @changed="test($event)"
            />
          </div>
          <div class="work-package-costs-equation">
            <ModularEquation
              :description="`${/*'Paid Out'*/''}`"
              :elements="total_paid_out_elements"
              :background_color="bg"
              :foreground_color="fg"
              @changed="test($event)"
            />
          </div>
        </div>

        <!-- 3x3 MATRIX -->
        <div v-if="show_budget" class="work-package-costs-equation">
          <ModularEquation
            :description="'Budget'"
            :elements="budget_elements"
            :background_color="bg"
            :foreground_color="fg"
            @changed="test($event)"
          />
        </div>
        <div class="work-package-costs-equation">
          <ModularEquation
            :description="'Tendered'"
            :elements="tendered_elements"
            :background_color="bg"
            :foreground_color="fg"
            @changed="test($event)"
          />
        </div>
        <div class="work-package-costs-equation">
          <ModularEquation
            :description="'Paid Out'"
            :elements="paid_out_elements"
            :background_color="bg"
            :foreground_color="fg"
            @changed="test($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import ModularEquation from '@/modules/WorkPackageWIP/ModularEquation.module.vue';
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      SubpageHeader,
      ModularEquation,
      LabelOutlined,
      DropDownOutlinedFlat,
      TText,
    },

    mixins: [
      WorkPackageWIPMixin,
      TColor,
    ],

    computed: {
      full_color() {
        return this.getColor();
      },

      show_total() {
        switch (this.strategy_index) {
          case 0: return true;
          case 1: return true;
          case 2: return true;
          case 3: return true;
          case 4: return true;
          default: return false;
        }
      },

      budget_elements() {
        let index = index;
        if(index < 0) index = 0;
        if(index > 4) index = 4; // NOTE: must be max index
        switch (this.strategy_index) {
          case 0: // FLAT RATE
            return [
              { label: 'Total', icon: 'mdi-wallet', value: '0', is_disabled: true },
            ];
          case 1: // UNIT PRICE
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-wallet', value: '0', is_disabled: true },
            ];
          case 2: // HOURLY WAGES
            return [
              { label: 'Labour', icon: 'mdi-account-hard-hat', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-wallet', value: '0', is_disabled: true },
            ];
          case 3: // MATERIAL PRICE
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-wallet', value: '0', is_disabled: true },
            ];
          case 4: // MATERIAL PRICE  AND HOURLY WAGES
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '+' },
              { label: 'Labour', icon: 'mdi-account-hard-hat', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-wallet', value: '0', is_disabled: true },
            ];
          default:
            return [];
        }
      },

      tendered_elements() {
        let index = index;
        if(index < 0) index = 0;
        if(index > 4) index = 4; // NOTE: must be max index
        switch (this.strategy_index) {
          case 0: // FLAT RATE
            return [
              { label: 'Total', icon: 'mdi-cart-variant', value: '0', is_disabled: true },
            ];
          case 1: // UNIT PRICE
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cart-variant', value: '0', is_disabled: true },
            ];
          case 2: // HOURLY WAGES
            return [
              { label: 'Labour', icon: 'mdi-account-hard-hat', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cart-variant', value: '0', is_disabled: true },
            ];
          case 3: // MATERIAL PRICE
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cart-variant', value: '0', is_disabled: true },
            ];
          case 4: // MATERIAL PRICE  AND HOURLY WAGES
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '+' },
              { label: 'Labour', icon: 'mdi-account-hard-hat', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cart-variant', value: '0', is_disabled: true },
            ];
          default:
            return [];
        }
      },

      paid_out_elements() {
        let index = this.strategy_index;
        if(index < 0) index = 0;
        if(index > 4) index = 4; // NOTE: must be max index
        switch (this.strategy_index) {
          case 0: // FLAT RATE
            return [
              { label: 'Total', icon: 'mdi-cash-multiple', value: '0', is_disabled: true },
            ];
          case 1: // UNIT PRICE
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cash-multiple', value: '0', is_disabled: true },
            ];
          case 2: // HOURLY WAGES
            return [
              { label: 'Labour', icon: 'mdi-account-hard-hat', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cash-multiple', value: '0', is_disabled: true },
            ];
          case 3: // MATERIAL PRICE
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cash-multiple', value: '0', is_disabled: true },
            ];
          case 4: // MATERIAL PRICE  AND HOURLY WAGES
            return [
              { label: 'Material', icon: 'mdi-wall', value: '0', is_disabled: !this.is_edit },
              { operator: '+' },
              { label: 'Labour', icon: 'mdi-account-hard-hat', value: '0', is_disabled: !this.is_edit },
              { operator: '=' },
              { label: 'Total', icon: 'mdi-cash-multiple', value: '0', is_disabled: true },
            ];
          default:
            return [];
        }
      },

      total_budget_elements() {
        return [
          { label: 'Total budget', icon: 'mdi-wallet', value: '0', is_disabled: !this.is_edit },
        ];
      },

      total_tendered_elements() {
        if(this.show_budget) {
          return [
            { label: 'Tendered costs', icon: 'mdi-cart-variant', value: '0', is_disabled: !this.is_edit },
            { operator: '/' },
            { label: 'Total budget', icon: 'mdi-wallet', value: '0', is_disabled: true },
          ];
        }
        else {
          return [
            { label: 'Tendered costs', icon: 'mdi-cart-variant', value: '0', is_disabled: !this.is_edit },
          ];
        }
      },

      total_paid_out_elements() {
        return [
          { label: 'Paid out', icon: 'mdi-cash-multiple', value: '0', is_disabled: !this.is_edit },
          { operator: '/' },
          { label: 'Tendered costs', icon: 'mdi-cart-variant', value: '0', is_disabled: true },
        ];
      },
    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: true,
      show_budget: false,
      strategy_index: 0,
    }),

    methods: {

    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  .work-package-costs-container,
  .work-package-costs-total {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
  }
  .work-package-costs-strategy {
    display: flex;
    align-items:
    flex-start;
    grid-gap: 8px;
  }
  .work-package-costs-equation {
    display: flex;
    align-items: center;
  }
</style>
